import React, { useEffect, useState, useRef } from "react";


const CountUpCircle = ({ value, duration = 1500, size = 100 }) => {
  const [count, setCount] = useState(0);
  const circleRef = useRef(null);
  const radius = size / 2 - 10; // 10 is stroke-width
  const circumference = 2 * Math.PI * radius;

  useEffect(() => {
    let start = 0;
    const end = parseInt(value);
    const incrementTime = 10;
    const step = (end - start) / (duration / incrementTime);

    const timer = setInterval(() => {
      start += step;
      if (start >= end) {
        start = end;
        clearInterval(timer);
      }
      setCount(Math.round(start));

      if (circleRef.current) {
        const offset = circumference - (circumference * Math.round(start)) / 100;
        circleRef.current.style.strokeDashoffset = offset;
      }
    }, incrementTime);

    return () => clearInterval(timer);
  }, [value, duration, circumference]);

  const getColor = (val) => {
    if (val <= 0) return "#d2232a"; 
    if (val <= 20) return "#f05860"; 
    if (val <= 40) return "#f8912a"; 
    if (val <= 60) return "#fff200"; 
    if (val <= 80) return "#59ba47"; 
    if (val =>100) return "#41813c";  
    return "#0a0a0aff"; 
  };

  return (
    <div className="esg-circle" style={{ width: size, height: size }}>
      <svg className="circle-svg" width={size} height={size}>
        <circle className="circle-bg" cx={size/2} cy={size/2} r={radius} />
        <circle
          ref={circleRef}
          className="circle-progress"
          cx={size/2}
          cy={size/2}
          r={radius}
          stroke={getColor(count)}
          strokeDasharray={circumference}
          strokeDashoffset={circumference}
        />
      </svg>
      <span style={{ color: getColor(count) }}>{count}%</span>
    </div>
  );
};

export default CountUpCircle;